export const PLAYER_OWNERSHIP_BATCH_SIZE = 5_000

export function chunkPlayerIds(playerIds: readonly string[]): string[][] {
  const uniqueIds = [...new Set(playerIds.filter(Boolean))]
  const chunks: string[][] = []

  for (let index = 0; index < uniqueIds.length; index += PLAYER_OWNERSHIP_BATCH_SIZE) {
    chunks.push(uniqueIds.slice(index, index + PLAYER_OWNERSHIP_BATCH_SIZE))
  }

  return chunks
}
